import { API_URL } from 'config/api';
import axios from 'axios';
import { SubscriptionStatus } from 'types/subscription';

export const getSubscriptionStatus = async (
  userId: string
): Promise<SubscriptionStatus> => {
  const { data } = await axios.get(
    `${API_URL}/user/${userId}/subscription-status`
  );
  return data.object;
};

export const createCustomerPortal = async (userId: string, returnUrl: string) => {
  const url = `${API_URL}/user/${userId}/stripe-portal`;
  const body = {
    returnUrl: returnUrl,
  };
  const { data } = await axios.post(url, body);
  return data.object;
};
